<template>
  <button type="button" class="btn btn-light" @click="$emit('click')">
    <slot>
      {{ label }}
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,  // to support just putting something in the slot
      default: ''
    }
  },

  emits: ['click']
}
</script>
